import React from 'react';
import {
  BottomNavigation,
  BottomNavigationItem,
  Paper,
  FontIcon, MenuItem, IconMenu, IconButton, Avatar,
} from 'material-ui';
import classNames from 'classnames';
import { connect } from 'react-redux';
import async from 'async';
import _ from 'lodash';
import Translate from 'translate';
import moment from 'moment';
import { injectIntl } from 'react-intl';

import ServiceService from 'services/ServiceService';
import XmlService from 'services/XmlService';
import CategoryService from 'services/CategoryService';
import ChannelOperationService from 'services/ChannelOperationService';
import UserService from 'services/UserService';
import AuthService from 'services/AuthService';
import UserGroupService from 'services/UserGroupService';
import NotificationsService from 'services/NotificationsService';
import AutomaticResponseService from 'services/AutomaticResponseService';
import ToneService from 'services/ToneService';
import ChannelService from 'services/ChannelService';
import Timeline from 'routes/app/components/Agent/Timeline/';
import Notifications from 'routes/app/components/Agent/Notifications/';
import ProfileTab from 'routes/app/components/Agent/ProfileTab/';
import ContactsTab from 'routes/app/components/Agent/ContactsTab/';
import ChannelsAssign from 'routes/app/components/Agent/ChannelsAssign/';
import ChannelsBar from 'routes/app/components/Agent/ChannelsBar/';
import ChatsBar from 'routes/app/components/Agent/ChatsBar/';
import ChannelDetail from 'routes/app/components/Agent/ChannelDetail/';
import ChatDetail from 'routes/app/components/Agent/ChatDetail/';
import ClientFolder from 'routes/app/components/Agent/ClientFolder/';
import WorkRequest from 'routes/app/components/Agent/WorkRequest/';
import WorkRequestOwnership from 'routes/app/components/Agent/WorkRequestOwnership/';
import WorkRequestTenant from 'routes/app/components/Agent/WorkRequestTenant/';
import WorkRequestPowerUpgrade from 'routes/app/components/Agent/WorkRequestPowerUpgrade/';
import ClientFolderHeader from 'routes/app/components/Agent/ClientFolderHeader/';




import SimplePanel from 'components/HTMLElements/Panel/Simple/';
import { Text } from 'components/FormElements/';
import { toggleAlertError, toggleLoading, updateNotifications, checkUserOnline } from 'stores/actions';
import SendServicesModal from 'routes/app/components/Agent/SendServicesModal/';
import SendServicesLECModal from 'routes/app/components/Agent/SendServicesLECModal/';
import Config from 'constants/Config'
import NetworkService from "../../../../services/NetworkService";
import ReactTooltip from "react-tooltip";
import MoreHorizIcon from "material-ui/svg-icons/navigation/more-horiz";
import PhoneCallModal from 'routes/app/components/Agent/PhoneCallModal';
import ChatService from 'services/ChatService';
import { animateScroll } from "react-scroll";

class Agent extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      selectedChannels: [],
      selectedChats: [],
      selectedLeftTabIndex: props.chatActive && props.user && props.user.agentSocialTab === 'chat' ? 1 : 0,
      selectedRightTabIndex: 2,
      options: {},
      contacts: {},
      sendServicesModalOpened: false,
      phoneCallModalOpened: false,
      messagesDate: null,
      workRequestTabIndex:0,
    };

    this.isFetchingNotifications = false;
    this.pendingChannelsCount = {};
    this.messages = [];
    this.messagesHasMore = true;
    this.getChannel = this.getChannel.bind( this );
    this.getChannels = this.getChannels.bind( this );
    this.getChannelData = this.getChannelData.bind( this );
    this.onCloseActiveChannel = this.onCloseActiveChannel.bind( this );
    this.reloadActiveChannel = this.reloadActiveChannel.bind( this );
    this.reloadAssignChannelsData = this.reloadAssignChannelsData.bind( this );
    this.toggleAllChannels = this.toggleAllChannels.bind( this );
    this.toggleSelectedChannels = this.toggleSelectedChannels.bind( this );
    this.toggleSendServicesModal = this.toggleSendServicesModal.bind( this );
    this.toggleClientFolder = this.toggleClientFolder.bind( this );
    this.reloadChannelPhoneOpenedData = this.reloadChannelPhoneOpenedData.bind( this );
    this.togglePhoneCallModal = this.togglePhoneCallModal.bind( this );
    this.toggleAllChats = this.toggleAllChats.bind( this );
    this.toggleSelectedChats = this.toggleSelectedChats.bind( this );
    this.reloadAssignChatsData = this.reloadAssignChatsData.bind( this );
    this.getChatData = this.getChatData.bind( this );
    this.getChatMessages = this.getChatMessages.bind( this );
    this.onCloseActiveChat = this.onCloseActiveChat.bind( this );
    this.reloadActiveChat = this.reloadActiveChat.bind( this );
    this.toggleWorkRequest = this.toggleWorkRequest.bind( this );
    this.setWorkRequestTabIndex = this.setWorkRequestTabIndex.bind( this );
  }

  componentDidMount() {
    this.getData();
  }

  componentWillReceiveProps( nextProps ) {
    if( nextProps.lastCall && this.props.lastCall !== nextProps.lastCall && !this.state.phoneCallModalOpened ) {
      this.setState( { phoneCallModalOpened: true, phoneCalling: nextProps.phoneCalling } )
    }
    if( nextProps.loadChannelId && _.get( this.state, 'activeChannel.id' ) !== nextProps.loadChannelId
      && this.props.loadChannelDate !== nextProps.loadChannelDate ) {
      this.getChannelData( nextProps.loadChannelId )
    }

    if( this.state.activeChat && nextProps.newMessageDataDate
      && this.state.activeChat.id === nextProps.newMessageData.channelId
      && this.props.newMessageDataDate !== nextProps.newMessageDataDate ) {
      this.messages = [...this.messages, nextProps.newMessageData];
      this.setState( { messagesDate: new Date().valueOf() }, () => {
        if( nextProps.newMessageData.agent )
          animateScroll.scrollToBottom( {
            containerId: 'messagesContainer',
            duration: 100,
          } );
      } )
    }

    if( this.state.activeChat && nextProps.newMessageFileDataDate
      && this.state.activeChat.id === nextProps.newMessageFileData.channelId
      && this.props.newMessageFileDataDate !== nextProps.newMessageFileDataDate ) {
      if( _.get( nextProps, 'newMessageFileData.ref' ) && !_.get( nextProps, 'newMessageFileData.id' ) ) {
        if( _.get( nextProps, 'newMessageFileData.status' ) === 'ERROR' ) {
          const itemIndex = _.findIndex( this.messages, { ref: nextProps.newMessageFileData.ref } );
          if( itemIndex !== -1 ) {
            this.messages[itemIndex] = nextProps.newMessageFileData;
            this.setState( { messagesDate: new Date().valueOf() }, () => {
              if( nextProps.newMessageFileData.agent )
                animateScroll.scrollToBottom( {
                  containerId: 'messagesContainer',
                  duration: 100,
                } );
            } )
          }
        } else {
          this.messages = [...this.messages, nextProps.newMessageFileData];
          this.setState( { messagesDate: new Date().valueOf() }, () => {
            if( nextProps.newMessageFileData.agent )
              animateScroll.scrollToBottom( {
                containerId: 'messagesContainer',
                duration: 100,
              } );
          } )
        }
      }

      if( _.get( nextProps, 'newMessageFileData.ref' ) && _.get( nextProps, 'newMessageFileData.id' ) ) {
        const itemIndex = _.findIndex( this.messages, { ref: nextProps.newMessageFileData.ref } );
        if( itemIndex !== -1 ) {
          this.messages[itemIndex] = nextProps.newMessageFileData;
          this.setState( { messagesDate: new Date().valueOf() } )
        }
      }
    }
  }

  getData() {
    const { toggleLoading, user } = this.props;
    toggleLoading( true );
    async.parallel( {
      options: this.getOptions.bind( this ),
      channels: ( cb ) => {
        let type = [];
        const filters = { search: 1 };
        if( user.filterFacebook ) type.push( 'facebook' );
        if( user.filterTwitter ) type.push( 'twitter' );
        if( user.filterPhone ) type.push( 'phone' );
        if( user.filterEmail ) type.push( 'email' );
        if( user.filterWalkIn ) type.push( 'walk_in' );

        if( type.length ) filters.type = type.join( ',' );
        if( user.filterMy ) filters.current_agent = user.filterMy;
        if( user.filterLastService ) filters.service = Number( user.filterLastService );
        if( user.filterLastCategory ) filters.category = user.filterLastCategory;
        if( user.filterLastWords ) filters.words = user.filterLastWords;
        if( user.filterLastFrom ) filters.from = user.filterLastFrom;
        if( user.filterLastViaSocialType ) filters.viaSocialType =
          user.filterFacebook && user.filterLastViaSocialType && user.filterLastViaSocialType.indexOf( 'FB_' ) !== -1 ?
            user.filterLastViaSocialType : user.filterTwitter && user.filterLastViaSocialType.indexOf( 'FB_' ) === -1 ?
            user.filterLastViaSocialType : null
        ;
        if( user.filterLastTwHashTag ) filters.twHashTag = user.filterLastTwHashTag;
        if( user.filterLastTwAccount ) filters.twAccount = user.filterLastTwAccount;

        this.getChannels( filters, cb )
      },
      chats: ( cb ) => {
        if( !this.props.chatActive ) return cb();
        const filters = { search: 1 };

        if( user.filterMy ) filters.current_agent = user.filterMy;
        if( user.chatFilterLastService ) filters.chatService = Number( user.chatFilterLastService );
        if( user.chatFilterLastCategory ) filters.chatCategory = user.chatFilterLastCategory;
        if( user.chatFilterLastWords ) filters.chatWords = user.chatFilterLastWords;
        if( user.chatFilterLastFrom ) filters.chatFrom = user.chatFilterLastFrom;

        this.getChats( filters, cb )
      },
      // notifications: this.getNotifications.bind( this ),
      contacts: this.getContacts.bind( this, { reloadPagination: true } ),
    }, ( error, results ) => {
      toggleLoading( false );

      if( !error ) {
        const { options, channels, contacts, chats } = results;
        this.setState( { options, channels, contacts, chats } )
      }
    } )
  }

  getOptions( cb ) {
    async.parallel( {
        users: this.getUsers.bind( this ),
        categories: this.getCategories.bind( this ),
        services: this.getServices.bind( this ),
        groups: this.getGroups.bind( this ),
        responses: this.getAutomaticResponses.bind( this ),
        tones: this.getTones.bind( this ),
        socialAccounts: this.getSocialAccounts.bind( this ),
      }, ( error, results ) => cb( error, results )
    )
  }

  getAutomaticResponses( cb ) {
    AutomaticResponseService.getAutomaticResponses( { 'filters[active]': 1, 'limit':-1 } ).then( ( response ) => {
      if( response.errors ) return cb( response.errors );
      return cb( null, response.data.data )
    } )
  }

  getTones( cb ) {
    ToneService.getTones().then( ( response ) => {
      if( response.errors ) return cb( response.errors );
      return cb( null, response.data.data )
    } )
  }

  getSocialAccounts( cb ) {
    NetworkService.getAccounts().then( ( response ) => {
      if( response.errors ) return cb( response.errors );
      const options = [];
      if( _.get( response.data, 'FB.FB_MESSAGE' ) )
        options.push( { id: _.get( response.data, 'FB.FB_MESSAGE' ), name: 'Facebook Direct Message', type: 'fb' } );
      if( _.get( response.data, 'FB.FB_FEED' ) )
        options.push( { id: _.get( response.data, 'FB.FB_FEED' ), name: 'Facebook Wall', type: 'fb' } );
      if( _.get( response.data, 'FB.FB_FEED_COMMENT' ) )
        options.push( { id: _.get( response.data, 'FB.FB_FEED_COMMENT' ), name: 'Facebook Comment', type: 'fb' } );

      if( _.get( response.data, 'TW.TW_CHAT' ) )
        options.push( { id: _.get( response.data, 'TW.TW_CHAT' ), name: 'Twitter Direct Message', type: 'tw' } );
       // options.push( { id: _.get( response.data, 'TW.TW_CHAT' ) , name: 'Twitter Chat', type: 'tw' } );
      if( _.get( response.data, 'TW.TW_TWEET_ACCOUNT' ) )
        options.push( { id: _.get( response.data, 'TW.TW_TWEET_ACCOUNT' ), name: 'Twitter Timeline', type: 'tw', } );
        /* options.push( ..._.map( response.data['TW']['TW_TWEET_ACCOUNT'], item => (
          { id: item, name: item, type: 'tw', subtype: 'account' }
        ) ) );
        */
      if( _.get( response.data, 'TW.TW_TWEET_HASHTAG' ) )
        options.push( { id: _.get( response.data, 'TW.TW_TWEET_HASHTAG' ), name: 'Twitter Hashtag', type: 'tw', } );
        /* options.push( ..._.map( response.data['TW']['TW_TWEET_HASHTAG'], item => (
          { id: item, name: item, type: 'tw', subtype: 'hashtag' }
        ) ) );
        */

      return cb( null, options )
    } )
  }

  getCategories( cb ) {
    CategoryService.getCategories( { 'filters[active]': 1, limit:-1 } ).then( ( response ) => {
      if( response.errors ) return cb( response.errors );
      return cb( null, response.data.data )
    } )
  }

  getGroups( cb ) {
    if( AuthService.getUserRole().isOperator ) return cb();

    UserGroupService.getUserGroups( { 'filters[active]': 1 } ).then( ( response ) => {
      if( response.errors ) return cb( response.errors );
      return cb( null, response.data.data )
    } )
  }

  getServices( cb ) {
    ServiceService.getServices( { 'filters[active]': 1 } ).then( ( response ) => {
      if( response.errors ) return cb( response.errors );
      return cb( null, response.data.data )
    } )
  }

  getUsers( cb ) {
    if( AuthService.getUserRole().isOperator )
      return cb( null, [{ id: this.props.user.userId, name: this.props.user.name }] );

    UserService.getUsers({limit:-1}).then( ( response ) => {
      if( response.errors ) return cb( response.errors );
      return cb( null, response.data.data )
    } )
  }


  getChannel( id, cb ) {
    if( !cb ) this.props.toggleLoading( true );

    ChannelService.getChannel( id ).then( ( response ) => {
      if( cb ) return cb( response.errors, response.data );
      if( response.data ) {
        const channels = _.cloneDeep( this.state.channels );
        let currentChannelIndex = _.findIndex( channels, { id } );
        let currentChannel = channels[currentChannelIndex];

        currentChannel.snippet = response.data.snippet;
        currentChannel.status = response.data.status;
        currentChannel.lastOperation = response.data.lastOperation;
        currentChannel.agent = response.data.agent;

        this.setState( { activeChannel: response.data, selectedRightTabIndex: 0, channels } )
      }
      this.props.toggleLoading( false );
    } )
  }

  getChannelData( id ) {
    this.props.toggleLoading( true );

    async.parallel( {
      activeChannel: this.getChannel.bind( this, id ),
      channelHistorical: this.getChannelHistorical.bind( this, id, null, true )
    }, ( error, results ) => {
      this.props.toggleLoading( false );

      if( !error ) {
        const channels = _.cloneDeep( this.state.channels );
        let currentChannelIndex = _.findIndex( channels, { id } );
        let currentChannel = channels[currentChannelIndex];

        if( currentChannel ) {
          if (results.activeChannel.status==='closed') this.props.toggleAlertError( this.props.intl.formatMessage( { id: 'channelHaveBeenClosed' } ) );
          currentChannel.snippet = results.activeChannel.snippet;
          currentChannel.status = results.activeChannel.status;
          currentChannel.lastOperation = results.activeChannel.lastOperation;
          currentChannel.agent = results.activeChannel.agent;
        }

        this.setState( { ...results, selectedRightTabIndex: 0, channels, activeChat: null } )
      }
    } )
  }

  getChannelHistorical( id, filters, reload = false, cb ) {
    if( reload && !cb ) this.props.toggleLoading( true );
    let filterParams = reload ? { limit: 10, offset: 0 } : {
      limit: 10,
      offset: this.state.channelHistorical.data.length
    };
    filterParams[`sortby[socialCreateTime]`] = 'DESC';
    if( filters ) {
      _.map( filters, ( value, filter ) => {
        filterParams[`filters[${filter}]`] = value;
      } );
    }

    if( !filterParams['filters[account_incms]'] ) {
      filterParams[`filters[channel]`] = id;
    }

    ChannelOperationService.getChannelOperations( filterParams )
      .then( ( response ) => {
        if( cb ) return cb( response.errors, response.data );

        if( reload ) this.props.toggleLoading( false );
        this.setState( {
          channelHistorical: {
            total: response.data.total,
            data: reload ? response.data.data : [...this.state.channelHistorical.data, ...response.data.data]
          }
        } )
      } );
  }

  offset = 0;

  getChannels( params = {}, cb ) {
    if( params.reloadPagination ) this.offset = 0;
    if( !params.reloadPagination && !params.keepPagination ) {
      if( params.isPrev ) this.offset = this.offset - 6;
      else if( this.state.channels && this.state.channels.length )
        this.offset = this.offset + 6;
    }

    const paginationParams = params.reloadPagination ? { limit: 6, offset: 0 } : { limit: 6, offset: this.offset };
    let filterParams = { ...paginationParams };
    filterParams[`sortby[socialCreateTime]`] = params.createdAtOrder || 'ASC';

    if( ( !cb && params.reloadPagination ) || params.toggleLoading ) this.props.toggleLoading( true );

    _.map( params, ( value, filter ) => {
      if( value && filter !== 'reloadPagination' && filter !== 'toggleLoading'
        && filter !== 'keepPagination' && filter !== 'limit' && filter !== 'offset'
        && filter !== 'createdAtOrder' && filter !== 'search' && filter !== 'isPrev' ) {
        filterParams[`filters[${filter}]`] = value;
        if( filter === 'from' ) {
          filterParams[`filters[${filter}]`] = moment( value ).format( 'YYYY-MM-DD' );
        }
        if( filter === 'words' ) {
          filterParams[`filters[${filter}]`] = value.trim().split( ' ' ).join( ',' );
        }
      }
      if( filter === 'search' ) {
        filterParams['search'] = 1;
      }
    } );

    filterParams[`filters[statusActive]`] = true;
    this.channelFilterParams = { ...params, ...paginationParams };
    ChannelService.getChannels( filterParams ).then( ( response ) => {
      if( cb ) {
        if( response.errors ) return cb( response.errors );
        this.userChannelsCount = parseInt( response.data.totalCurrent );
        this.channelsCount = parseInt( response.data.total );
        this.pendingChannelsCount = response.data.pending;
        return cb( null, response.data.data )
      }

      if( response.data ) {
        this.userChannelsCount = parseInt( response.data.totalCurrent );
        this.channelsCount = parseInt( response.data.total );
        this.pendingChannelsCount = response.data.pending;
        
        this.setState( {
          channels: response.data.data
        } );
      }
      this.props.toggleLoading( false );
    } )
  }

  chatOffset = 0;

  getChats( params = {}, cb ) {
    if( params.reloadPagination ) this.chatOffset = 0;
    if( !params.reloadPagination && !params.keepPagination ) {
      if( params.isPrev ) this.chatOffset = this.chatOffset - 6;
      else if( this.state.chats && this.state.chats.length )
        this.chatOffset = this.chatOffset + 6;
    }

    const paginationParams = params.reloadPagination ? { limit: 6, offset: 0 } : { limit: 6, offset: this.chatOffset };
    let filterParams = { ...paginationParams };
    filterParams[`sortby[socialCreateTime]`] = params.createdAtOrder || 'ASC';

    if( ( !cb && params.reloadPagination ) || params.toggleLoading ) this.props.toggleLoading( true );

    _.map( params, ( value, filter ) => {
      if( value && filter !== 'reloadPagination' && filter !== 'toggleLoading'
        && filter !== 'keepPagination' && filter !== 'limit' && filter !== 'offset'
        && filter !== 'createdAtOrder' && filter !== 'search' && filter !== 'isPrev' ) {
        filterParams[`filters[${filter}]`] = value;
        if( filter === 'chatFrom' ) {
          filterParams[`filters[${filter}]`] = moment( value ).format( 'YYYY-MM-DD' );
        }
        if( filter === 'chatWords' ) {
          filterParams[`filters[${filter}]`] = value.trim().split( ' ' ).join( ',' );
        }
      }
      if( filter === 'search' ) {
        filterParams['search'] = 1;
      }
    } );

    filterParams['filters[type]'] = 'chat';
    filterParams[`filters[statusActive]`] = true;
    this.chatFilterParams = { ...params, ...paginationParams };
    ChannelService.getChannels( filterParams ).then( ( response ) => {
      if( cb ) {
        if( response.errors ) return cb( response.errors );
        this.chatsCount = parseInt( response.data.total );
        this.pendingChatsCount = response.data.pending;
        return cb( null, response.data.data )
      }

      if( response.data ) {
        this.chatsCount = parseInt( response.data.total );
        this.pendingChatsCount = response.data.pending;
        this.setState( {
          chats: response.data.data
        } );
      }
      this.props.toggleLoading( false );
    } )
  }

  getChat( id, cb ) {
    if( !cb ) this.props.toggleLoading( true );

    ChannelService.getChannel( id ).then( ( response ) => {
      if( cb ) return cb( response.errors, response.data );
      if( response.data ) {
        const chats = _.cloneDeep( this.state.chats );
        let currentChannelIndex = _.findIndex( chats, { id } );
        let currentChannel = chats[currentChannelIndex];

        currentChannel.status = response.data.status;
        currentChannel.agent = response.data.agent;

        this.setState( { activeChat: response.data, selectedRightTabIndex: 0, chats } )
      }
      this.props.toggleLoading( false );
    } )
  }

  getChatData( id ) {
    if( !this.props.chatActive ) return;
    this.props.toggleLoading( true );

    async.parallel( {
      activeChat: this.getChat.bind( this, id ),
      messages: this.getChatMessages.bind( this, id, true ),
      channelHistorical: this.getChannelHistorical.bind( this, id, null, true ),
    }, ( error, results ) => {
      this.props.toggleLoading( false );

      if( !error ) {
        const chats = _.cloneDeep( this.state.chats );
        let currentChannelIndex = _.findIndex( chats, { id } );
        let currentChannel = chats[currentChannelIndex];

        if( currentChannel ) {
          currentChannel.status = results.activeChat.status;
          currentChannel.agent = results.activeChat.agent;
        }

        this.messages = _.reverse( results.messages );
        this.messagesHasMore = results.messages.length >= 20;

        if( results.activeChat && results.activeChat.status === 'open' && results.activeChat.agent ) {
          this.props.checkUserOnline( {
            channelId: results.activeChat.id,
            date: new Date().valueOf()
          } );
        }
        this.setState( {
          activeChat: results.activeChat,
          channelHistorical: results.channelHistorical,
          selectedRightTabIndex: 0,
          chats,
          activeChannel: null,
          messageDate: new Date().valueOf()
        } )
      }
    } )
  }

  getChatMessages( id, restart, cb ) {
    // if( !cb ) this.props.toggleLoading( true );

    const params = {
      'filters[channel]': id,
      'sortby[id]': 'DESC'
    };
    if( !restart ) {
      params['filters[fromid]'] = this.messages[0].id;
    }
    ChatService.getMessages( params ).then( ( response ) => {
      if( cb ) return cb( response.errors, response.data ? response.data.data : [] );

      //  this.props.toggleLoading( false );
      if( response.data ) {
        this.messages = restart ? _.reverse( response.data.data ) : [..._.reverse( response.data.data ), ...this.messages];
        this.messagesHasMore = response.data.data.length >= 20;

        this.setState( { messageDate: new Date().valueOf() } )
      }
    } )
  }

  getNotifications( cb ) {
    if( !this.isFetchingNotifications ) {
      this.isFetchingNotifications = true;
      NotificationsService.getNotifications( { limit: 10, offset: this.props.notifications.data.length + 1 } )
        .then( ( response ) => {
          this.isFetchingNotifications = false;
          if( response.errors ) return cb ? cb( response.errors ) : [];

          this.props.updateNotifications( response.data );
          if( cb ) return cb()
        } )
    }
  }

  getContacts( params, cb ) {
    const paginationParams = ( params && params.keepPagination ) ?
      { limit: params.offset + 10, offset: 0 }
      : ( params && params.reloadPagination ) ? { limit: 10, offset: 0 }
        : { limit: 10, offset: this.state.contacts.data.length };
    let filterParams = { ...paginationParams };
    let type = '';
    if (params) { 
      type += params.hasOwnProperty('twAccountCustomer') ? 'twitter' : '';
      type += params.hasOwnProperty('fbAccountCustomer') ? 'facebook' : '';
      type += params.hasOwnProperty('emailAccountCustomer') ? 'email' : '';
      type += params.hasOwnProperty('phoneCustomer') ? 'phone' : ''; 
      type += params.hasOwnProperty('walk_in') ? 'walk_in' : ''; 
    } 
    if (type != ''){
      filterParams[`filters[type]`] = type;
    }
    
    filterParams[`filters[status]`] = 'closed';
    filterParams[`sortby[socialCreateTime]`] = 'DESC';
    _.map( params, ( value, filter ) => {
      if( value && filter !== 'reloadPagination'
        && filter !== 'keepPagination' && filter !== 'limit' && filter !== 'offset' ) {
        filterParams[`filters[${filter}]`] = value;
        if( filter === 'words' ) {
          filterParams[`filters[${filter}]`] = value.trim().split( ' ' ).join( ',' );
        }
      }
    } );

    this.contactFilterParams = { ...params, ...paginationParams };
    ChannelService.getChannels( filterParams )
      .then( ( response ) => {
        let customers = [];
        if( !response.errors ) {
          customers = _.map( response.data.data, ( channel ) => {
            return {
              ...channel,
              channelUid: channel.id,
            }
          } );
        }

        if( cb ) {
          if( response.errors ) return cb( response.errors );
          return cb( null, {
            total: response.data.total,
            data: customers
          } );
        }

        this.setState( {
          contacts: {
            total: response.data.total,
            data: ( params && params.reloadPagination ) ? customers : [...this.state.contacts.data, ...customers]
          }
        } )
      } );
  }


  onCloseActiveChannel() {
    this.setState( { activeChannel: null, selectedRightTabIndex: 2 } )
  }

  onCloseActiveChat() {
    this.setState( { activeChat: null, selectedRightTabIndex: 2 } )
  }

  setWorkRequestTabIndex( tabIndex ){
    this.setState( { workRequestTabIndex: tabIndex } )
  }

  reloadAssignChannelsData() {
    this.props.toggleLoading( true );

    async.parallel( {
      channels: this.getChannels.bind( this, {
        ...this.channelFilterParams,
        reloadPagination: false,
        keepPagination: true
      } ),
      activeChannel: ( cb ) => {
        if( !this.state.activeChannel ) return cb();
        return this.getChannel( this.state.activeChannel.id, cb )
      },
      channelHistorical: ( cb ) => {
        if( !this.state.activeChannel ) return cb();
        return this.getChannelHistorical( this.state.activeChannel.id, null, true, cb )
      },
      contacts: this.getContacts.bind( this, { ...this.contactFilterParams, keepPagination: true } ),
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( !error ) this.setState( results )
    } );
  }

  reloadAssignChatsData() {
    this.props.toggleLoading( true );

    async.parallel( {
      chats: this.getChats.bind( this, {
        ...this.chatFilterParams,
        reloadPagination: false,
        keepPagination: true
      } ),
      activeChat: ( cb ) => {
        if( !this.state.activeChat ) return cb();
        return this.getChat( this.state.activeChat.id, cb )
      },
      channelHistorical: ( cb ) => {
        if( !this.state.activeChat ) return cb();
        return this.getChannelHistorical( this.state.activeChat.id, null, true, cb )
      },
      contacts: this.getContacts.bind( this, { ...this.contactFilterParams, keepPagination: true } ),
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( !error ) this.setState( results )
    } );
  }

  reloadStatusChangeOnChannel( id, cb ) {
    this.props.toggleLoading( true );

    async.parallel( {
      channels: this.getChannels.bind( this, {
        ...this.channelFilterParams,
        reloadPagination: false,
        keepPagination: true
      } ),
      activeChannel: this.getChannel.bind( this, id ),
      channelHistorical: this.getChannelHistorical.bind( this, id, null, true ),
      contacts: this.getContacts.bind( this, { ...this.contactFilterParams, keepPagination: true } ),
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( !error ) this.setState( results, cb )
    } );
  }

  reloadChannelPhoneOpenedData( id ) {
    this.props.toggleLoading( true );

    async.parallel( {
      channels: this.getChannels.bind( this, {
        ...this.channelFilterParams,
        reloadPagination: false,
        keepPagination: true
      } ),
      activeChannel: this.getChannel.bind( this, id ),
      channelHistorical: this.getChannelHistorical.bind( this, id, null, true ),
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( !error ) this.setState( { ...results, selectedRightTabIndex: 0 } )
    } );
  }

  reloadStatusChangeOnChat( id, cb ) {
    this.props.toggleLoading( true );

    async.parallel( {
      chats: this.getChats.bind( this, {
        ...this.channelFilterParams,
        reloadPagination: false,
        keepPagination: true
      } ),
      activeChat: this.getChat.bind( this, id ),
      channelHistorical: this.getChannelHistorical.bind( this, id, null, true ),
      contacts: this.getContacts.bind( this, { ...this.contactFilterParams, keepPagination: true } ),
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( !error ) this.setState( results, cb )
    } );
  }

  reloadActiveChannel( channel ) {
    if( channel ) this.setState( { activeChannel: channel, activeClientFolder: false, activeWorkRequest:false } );
    else if( this.state.activeClientFolder ) this.setState( { activeClientFolder: false, activeWorkRequest:false } );
  }

  reloadActiveChat( chat ) {
    if( chat ) this.setState( { activeChat: chat, activeClientFolder: false, activeWorkRequest:false } );
    else if( this.state.activeClientFolder ) this.setState( { activeClientFolder: false, activeWorkRequest:false } );
  }

  setActiveTabRight( index ) {
    this.setState( { selectedRightTabIndex: index } )
  }

  setActiveTabLeft( index ) {
    this.setState( { selectedLeftTabIndex: index, selectedChannels: [], selectedChats: [] } )
  }

  toggleAllChannels() {
    const { selectedChannels, channels } = this.state;
    const match = _.intersectionBy( selectedChannels, channels, 'id' );
    const unselected = _.differenceBy( this.state.selectedChannels, match, 'id' );
    this.setState( {
      selectedChannels: match.length !== channels.length ?
        [...unselected, ..._.cloneDeep( this.state.channels )] : []
    } )
  }

  toggleClientFolder() {
    if( this.state.activeClientFolder ) return this.setState( { activeClientFolder: false } );

    if( this.props.activeAccount ) {
      // if( this.selectedAccount === this.props.activeAccount.idAccount ) return this.setState( { activeClientFolder: true } );
      
      this.selectedAccount = this.props.activeAccount.idAccount;
      this.setState( { activeClientFolder: true } );
      if( this.props.clientFolderIframe ) {
        let incmsDomain = '';
        switch( process.env.NODE_ENV ) {
          case 'development':
            incmsDomain = Config.incmsDevUrl;
            this.setState( { activeClientFolder: true }, () => {
              const xml = XmlService.getXml( this.props.activeAccount.idAccount, this.props.locale );
              const myIframe = document.getElementById( "myIframe" );
              const idoc = myIframe.contentDocument || myIframe.contentWindow.document; // IE compat
              idoc.open();
              idoc.write( `<form method="get"  action="${incmsDomain}/InCMS/servlet/isf.servlets.gcrs.ReporterServlet">` );

              idoc.write( '</form>' );
              idoc.close();
              idoc.getElementsByTagName( 'form' )[0].submit();
            } );
            break;
          case 'production':
            incmsDomain = Config.incmsProdUrl;
            this.setState( { activeClientFolder: true }, () => {
              const xml = XmlService.getXml( this.props.activeAccount.idAccount, this.props.locale );
              const myIframe = document.getElementById( "myIframe" );
              const idoc = myIframe.contentDocument || myIframe.contentWindow.document; // IE compat
              idoc.open();
              idoc.write( `<form method="post" enctype="text/plain" action="${incmsDomain}/InCMS/servlet/isf.servlets.gcrs.ReporterServlet">` );

              idoc.write( '<textarea name="xml"></textarea>' );
              idoc.write( '</form>' );
              idoc.close();
              idoc.getElementsByTagName( 'textarea' )[0].value = xml;
              idoc.getElementsByTagName( 'form' )[0].submit();
            } );
            break;
          case 'qa':
            incmsDomain = Config.incmsQaUrl;
            this.setState( { activeClientFolder: true }, () => {
              const xml = XmlService.getXml( this.props.activeAccount.idAccount, this.props.locale );
              const myIframe = document.getElementById( "myIframe" );
              const idoc = myIframe.contentDocument || myIframe.contentWindow.document; // IE compat
              idoc.open();
              idoc.write( `<form method="post" enctype="text/plain" action="${incmsDomain}/InCMS/servlet/isf.servlets.gcrs.ReporterServlet">` );

              idoc.write( '<textarea name="xml"></textarea>' );
              idoc.write( '</form>' );
              idoc.close();
              idoc.getElementsByTagName( 'textarea' )[0].value = xml;
              idoc.getElementsByTagName( 'form' )[0].submit();
            } );
            break;
        }
      }
    }
  }

  toggleWorkRequest() {
    if( this.state.activeWorkRequest ) return this.setState( { activeWorkRequest: false } );

    // if( this.props.activeAccount ) {
      // if( this.selectedAccount === this.props.activeAccount.idAccount ) return this.setState( { activeClientFolder: true } );

      // this.selectedAccount = this.props.activeAccount.idAccount;
      this.setState( { activeWorkRequest: true } );

      if( this.props.activeWorkRequestIframe ) {
        let incmsDomain = '';
        switch( process.env.NODE_ENV ) {
          case 'development':
            incmsDomain = Config.incmsDevUrl;
            this.setState( { activeWorkRequest: true }, () => {
              const xml = XmlService.getXml( this.props.activeAccount.idAccount, this.props.locale );
              const myIframe = document.getElementById( "myIframe" );
              const idoc = myIframe.contentDocument || myIframe.contentWindow.document; // IE compat
              idoc.open();
              idoc.write( `<form method="get"  action="${incmsDomain}/InCMS/servlet/isf.servlets.gcrs.ReporterServlet">` );

              idoc.write( '</form>' );
              idoc.close();
              idoc.getElementsByTagName( 'form' )[0].submit();
            } );
            break;
          case 'production':
            incmsDomain = Config.incmsProdUrl;
            this.setState( { activeWorkRequest: true }, () => {
              const xml = XmlService.getXml( this.props.activeAccount.idAccount, this.props.locale );
              const myIframe = document.getElementById( "myIframe" );
              const idoc = myIframe.contentDocument || myIframe.contentWindow.document; // IE compat
              idoc.open();
              idoc.write( `<form method="post" enctype="text/plain" action="${incmsDomain}/InCMS/servlet/isf.servlets.gcrs.ReporterServlet">` );

              idoc.write( '<textarea name="xml"></textarea>' );
              idoc.write( '</form>' );
              idoc.close();
              idoc.getElementsByTagName( 'textarea' )[0].value = xml;
              idoc.getElementsByTagName( 'form' )[0].submit();
            } );
            break;
          case 'qa':
            incmsDomain = Config.incmsQaUrl;
            this.setState( { activeWorkRequest: true }, () => {
              const xml = XmlService.getXml( this.props.activeAccount.idAccount, this.props.locale );
              const myIframe = document.getElementById( "myIframe" );
              const idoc = myIframe.contentDocument || myIframe.contentWindow.document; // IE compat
              idoc.open();
              idoc.write( `<form method="post" enctype="text/plain" action="${incmsDomain}/InCMS/servlet/isf.servlets.gcrs.ReporterServlet">` );

              idoc.write( '<textarea name="xml"></textarea>' );
              idoc.write( '</form>' );
              idoc.close();
              idoc.getElementsByTagName( 'textarea' )[0].value = xml;
              idoc.getElementsByTagName( 'form' )[0].submit();
            } );
            break;
        }
      }
    //}
  }

  toggleSelectedChannels( item, isChecked ) {
    const selectedChannels = _.cloneDeep( this.state.selectedChannels );
    if( !isChecked ) {
      const index = _.findIndex( selectedChannels, { id: item.id } );
      selectedChannels.splice( index, 1 )
    } else {
      selectedChannels.push( item )
    }

    this.setState( { selectedChannels } )
  }

  toggleAllChats() {
    const { selectedChats, chats } = this.state;
    const match = _.intersectionBy( selectedChats, chats, 'id' );
    const unselected = _.differenceBy( selectedChats, match, 'id' );
    this.setState( {
      selectedChats: match.length !== chats.length ?
        [...unselected, ..._.cloneDeep( chats )] : []
    } )
  }

  toggleSelectedChats( item, isChecked ) {
    const selectedChats = _.cloneDeep( this.state.selectedChats );
    if( !isChecked ) {
      const index = _.findIndex( selectedChats, { id: item.id } );
      selectedChats.splice( index, 1 )
    } else {
      selectedChats.push( item )
    }

    this.setState( { selectedChats } )
  }

  toggleSendServicesModal() {
    this.setState( { sendServicesModalOpened: !this.state.sendServicesModalOpened } )
  }

  submitContactSearch = ( values ) => {
    let dataToSend = { reloadPagination: true };
    dataToSend[values.typeSearch] = values.value;
    this.getContacts( dataToSend )
  };

  togglePhoneCallModal() {
    this.setState( { phoneCallModalOpened: !this.state.phoneCallModalOpened } )
  }

  render() {
    const {
      activeChannel, activeClientFolder, activeWorkRequest, channelHistorical, channels, options, selectedChannels, selectedLeftTabIndex,
      selectedRightTabIndex, sendServicesModalOpened, chats, selectedChats, activeChat, messagesDate, workRequestTabIndex
    } = this.state;
    const activeChannelHasAccount = _.get( activeChannel, 'accounts', [] ).length;
    const activeChatHasAccount = _.get( activeChat, 'accounts', [] ).length;
    const { extraMenu, chatActive, phoneActive, externalCodes, externalCustomer } = this.props;
    const hasAccount = activeChat ? activeChatHasAccount : activeChannelHasAccount;
    const channelChat = activeChat ? activeChat : activeChannel;

    let linkToTwitter = "";
    let linkToFacebook = "";

    if(!!channelHistorical){
      if(!!activeChannel){
        try{
          linkToFacebook = `https://www.facebook.com/${activeChannel.socialNetwork.fbPage}`;
          linkToTwitter = `http://twitter.com/${activeChannel.twAccount}`;  
        } catch (e) {
          
        }
        // console.log(channelHistorical.data[0].via)
      if(channelHistorical.data[0].via === "fb_feed_comment" || channelHistorical.data[0].via === "fb_feed"){
        try{
          let lastOperation = activeChannel.lastOperation.socialId;
          // console.log(activeChannel.socialNetwork.fbPage)
          if(activeChannel.socialNetwork.fbPage != null){
            linkToFacebook = `https://www.facebook.com/${lastOperation}`;
          }
        } catch (e) {
          linkToFacebook = `https://www.facebook.com/messages/t/${activeChannel.socialNetwork.fbPage}`;
        }
      }    
      if(channelHistorical.data[0].via === "fb_chat"){
        try{
          let agentAccount = activeChannel.lastOperation.socialParentId;
          let aux = agentAccount.split('_');
          if(activeChannel.socialNetwork.fbPage != null){
            linkToFacebook = `https://www.facebook.com/${activeChannel.socialNetwork.fbPage}/inbox/${aux[1]}`;
          }
          else{
            linkToFacebook = `https://www.facebook.com/messages/t/${aux[1]}`;
          }
        } catch (e) {
          linkToFacebook = `https://www.facebook.com/messages/t/${activeChannel.socialNetwork.fbPage}`;
        }
 
      }
      if(channelHistorical.data[0].via === "tw_tweet_account"){
        linkToTwitter = `http://twitter.com/${activeChannel.twAccount}/status/${activeChannel.lastOperation.socialId}`;
      }
    }
      //console.log(channelHistorical.data[0].via,"via")
      try{
        if(channelHistorical.data[0].via === "tw_chat"){
          let agentAccount = activeChannel.socialNetwork.token;
          let aux = agentAccount.split('-');
          //console.log(Number(aux[0]),'Auxvar')
          //console.log(activeChannel.twId,"otherone")
          if(Number(aux[0]) < Number(activeChannel.twId)){
            linkToTwitter = `http://twitter.com/messages/${aux[0]}-${activeChannel.twId}`;
          }
          else{
            linkToTwitter = `http://twitter.com/messages/${activeChannel.twId}-${aux[0]}`;
          }
          
        }
      } catch(e){

      }
    }
    //console.log(linkToTwitter,"LInkTo twitter");
    return (
      <div className="d-flex page-agent">
        <div className={classNames( 'col-md-3 p-0', { 'd-none': (activeClientFolder || activeWorkRequest ) } )}>
          <div className="box box-default box-left m-0 no-shadow border-right border-gray-1 no-border-radius">
            <div className="box-header pointer p-0 border-bottom-0">
              <Paper zDepth={1} style={{ boxShadow: 'none', borderBottom: '1px solid #E9E9E9' }}>
                {chatActive ?
                  <BottomNavigation selectedIndex={selectedLeftTabIndex} style={{ height: 48 }}>
                    <BottomNavigationItem
                      style={{ paddingTop: 0, paddingBottom: 0 }}
                      label={
                        <div className={classNames( 'mdl-badge d-xl-inline mt-3 mt-xl-0', {
                          'mdl-badge--no-background': selectedLeftTabIndex !== 0
                        } )}
                             data-badge={this.channelsCount}>
                          <i className="fa fa-share-alt mr-1 d-block d-xl-inline"/>
                          <span className="d-block d-xl-inline" style={{ fontSize: selectedLeftTabIndex !== 0 ? 14 : 16 }}><Translate
                            id="social"/></span>
                        </div>
                      }
                      icon={<span/>}
                      onClick={() => this.setActiveTabLeft( 0 )}
                    />

                    <BottomNavigationItem
                      style={{ paddingTop: 0, paddingBottom: 0 }}
                      label={
                        <div className={classNames( 'mdl-badge d-xl-inline mt-3 mt-xl-0', {
                          'mdl-badge--no-background': selectedLeftTabIndex !== 1
                        } )}
                             data-badge={this.chatsCount}>
                          <i className="fa fa-comments mr-1 d-block d-xl-inline"/>
                          <span className="d-block d-xl-inline" style={{ fontSize: selectedLeftTabIndex !== 1 ? 14 : 16 }}><Translate
                            id="chats"/></span>
                        </div>
                      }
                      icon={<span/>}
                      onClick={() => this.setActiveTabLeft( 1 )}
                    />

                    <BottomNavigationItem
                      style={{ paddingTop: 0, paddingBottom: 0 }}
                      label={
                        <div className="mt-3 mt-xl-0">
                          <i className="fa fa-list mr-1 d-block d-xl-inline"/>
                          <span className="d-block d-xl-inline" style={{ fontSize: selectedLeftTabIndex !== 2 ? 14 : 16 }}><Translate
                            id="contacts"/></span>
                        </div>
                      }
                      icon={<span/>}
                      onClick={() => this.setActiveTabLeft( 2 )}
                    />
                  </BottomNavigation>
                  :
                  <BottomNavigation selectedIndex={selectedLeftTabIndex} style={{ height: 48 }}>
                    <BottomNavigationItem
                      style={{ paddingTop: 0, paddingBottom: 0 }}
                      label={
                        <div className={classNames( 'mdl-badge d-inline', {
                          'mdl-badge--no-background': selectedLeftTabIndex !== 0
                        } )}
                             data-badge={this.channelsCount}>
                          <i className="fa fa-share-alt mr-1"/>
                          <span style={{ fontSize: selectedLeftTabIndex !== 0 ? 14 : 16 }}><Translate
                            id="social"/></span>
                        </div>
                      }
                      icon={<span/>}
                      onClick={() => this.setActiveTabLeft( 0 )}
                    />

                    <BottomNavigationItem
                      style={{ paddingTop: 0, paddingBottom: 0 }}
                      label={
                        <div>
                          <i className="fa fa-list mr-1"/>
                          <span style={{ fontSize: selectedLeftTabIndex !== 1 ? 14 : 16 }}><Translate
                            id="contacts"/></span>
                        </div>
                      }
                      icon={<span/>}
                      onClick={() => this.setActiveTabLeft( 1 )}
                    />
                  </BottomNavigation>
                }
              </Paper>
            </div>

            <div className={classNames( 'box-body p-0', { 'd-none': selectedLeftTabIndex !== 0 } )}>
              <ChannelsBar data={channels}
                           totalCurrentUser={this.userChannelsCount}
                           totalChannels={this.channelsCount}
                           totalPendingChannels={this.pendingChannelsCount}
                           activeChannel={activeChannel}
                           loadChannel={this.getChannelData}
                           options={options}
                           phoneCalling={this.props.phoneCalling}
                           selectedChannels={selectedChannels}
                           toggleAllChannels={this.toggleAllChannels}
                           toggleSelectedChannels={this.toggleSelectedChannels}
                           onReloadData={( data ) => {
                             if( selectedLeftTabIndex === 0 && !activeClientFolder && !activeWorkRequest ) this.getChannels( data )
                           }}
                           currentFilters={this.props.user}
                           onReloadChannelPhoneOpenedData={this.reloadChannelPhoneOpenedData}
                           onReloadChannels={() => this.getChannels( {
                             ...this.channelFilterParams,
                             reloadPagination: false,
                             keepPagination: true,
                             toggleLoading: true,
                           } )}
                           offset={this.offset}
              />
            </div>

            <div className={classNames( 'box-body p-0', { 'd-none': selectedLeftTabIndex !== 1 || !chatActive } )}>
              <ChatsBar data={chats}
                        totalChats={this.chatsCount}
                        offset={this.chatOffset}
                        activeChat={activeChat}
                        options={options}
                        selectedChats={selectedChats}
                        currentFilters={this.props.user}
                        loadChat={this.getChatData}
                        toggleAllChats={this.toggleAllChats}
                        toggleSelectedChats={this.toggleSelectedChats}
                        onReloadData={( data ) => {
                          if( selectedLeftTabIndex === 1 ) this.getChats( data )
                        }}
                        onReloadChats={() => this.getChats( {
                          ...this.chatFilterParams,
                          reloadPagination: false,
                          keepPagination: true,
                          toggleLoading: true,
                        } )}
              />
            </div>

            {( ( selectedLeftTabIndex === 2 && chatActive ) || ( selectedLeftTabIndex === 1 && !chatActive ) ) &&
            <ContactsTab contacts={this.state.contacts} options={options}
                         searchQuery={this.state.searchQuery}
                         loadMore={() => this.getContacts()}
                         onSearch={this.submitContactSearch}
                         onOpenChannel={( id ) => this.reloadStatusChangeOnChannel( id )}
                         loadChannel={( item ) => {
                           if( item.type === 'chat' ) {
                             this.getChatData( item.channelUid )
                           } else {
                             this.getChannelData( item.channelUid )
                           }
                         }}
            />
            }
            {/*<Notifications data={this.props.notifications}
                           setActiveChannel={this.getChannelData}
                           loadMoreNotifications={() => this.getNotifications()}
            />*/}
          </div>
        </div>

        {selectedChannels.length || selectedChats.length ?
          <div className="col-md-6 px-1">
            {!!selectedChannels.length &&
            <ChannelsAssign data={selectedChannels}
                            onClear={() => this.setState( { selectedChannels: [] } )}
                            onToggle={this.toggleSelectedChannels}
                            options={options}
                            onReloadData={this.reloadAssignChannelsData}
            />
            }
            {!!selectedChats.length &&
            <ChannelsAssign data={selectedChats}
                            onClear={() => this.setState( { selectedChats: [] } )}
                            onToggle={this.toggleSelectedChats}
                            options={options}
                            type="chat"
                            onReloadData={this.reloadAssignChatsData}
            />
            }
          </div>
          :
          <div className={classNames( {
            'col-md-12 px-0': ( activeClientFolder || activeWorkRequest),
            'col-md-6 px-1': ( !activeClientFolder && !activeWorkRequest),
          } )}>

            {( activeChannel || activeChat ) &&
            <div className="row m-0">
              <div className="col-md-12 p-0">
                <div className="bg-white row m-0 align-items-center no-border border-y border-gray-1 border-bottom"
                     style={{ minHeight: 48 }}>
                  {activeChat ?
                    <div className="col-md-6 d-flex align-items-center">
                      <Avatar size={35} src={_.get( activeChat, 'webPathThumbnail' )}/>
                      <h5 className="my-0 text-overflow ml-3">
                        {_.get( activeChat, 'name' )}
                      </h5>
                    </div> :
                    <div className="col-md-6">
                      <h5 className="m-0 align-self-center text-overflow pointer"> 
                      
                        {_.get( this.state, 'activeChannel.type' ) === 'facebook' &&
                        <span data-tip={activeChannel.faceId}>
                          <i className="fa fa-facebook-square mr-2 color-facebook"/>
                          {_.get( this.state, 'activeChannel.faceId' ) ?
                            <a href={linkToFacebook} target="_blank"
                               onClick={( e ) => e.stopPropagation()}> {activeChannel.name}</a>
                            : activeChannel.name}
                        </span>
                        }
                        {_.get( this.state, 'activeChannel.type' ) === 'twitter' &&
                        <span>
                          <i className="fa fa-twitter-square mr-2 color-twitter"/>
                          {_.get( this.state, 'activeChannel.twAccount' ) ?
                            <a href={linkToTwitter} target="_blank"
                               onClick={( e ) => e.stopPropagation()}> {activeChannel.twAccount}</a>
                            : null}
                        </span>
                        }
                        {_.get( this.state, 'activeChannel.type' ) === 'phone' &&
                        <i className="fa fa-phone-square mr-2"/>
                        }
                        {_.get( this.state, 'activeChannel.type' ) === 'email' &&
                        <span><i
                          className="fa fa-envelope color-danger mr-2"/>{_.get( this.state, 'activeChannel.email' )}</span>
                        }
                        {_.get( this.state, 'activeChannel.type' ) === 'walk_in' &&
                        <span><i
                          className="fa fa-user mr-2"/>{_.get( this.state, 'activeChannel.name' )}</span>
                        }

                        {_.get( this.state, 'activeChannel.type' ) === 'phone' &&
                        _.get( this.state, 'activeChannel.phone' )
                        }
                      </h5>
                    </div>
                  }
                  <div className="col-md-6 text-right pl-0 d-flex align-items-center justify-content-end">
                    {!!extraMenu && extraMenu.length <= 2 && !activeClientFolder && !activeWorkRequest &&
                    _.map( extraMenu, item => {
                      if( item === 'custom_folder' && !!hasAccount && channelChat.status === 'open' ) {
                        return <span className="color-gray-4 pointer font-weight-light mr-3" key={item}
                                     onClick={this.toggleClientFolder}>
                            <span><i className="fa fa-folder"/> <Translate id="clientFolder"/></span>
                          </span>
                      }
                      if( item === 'send_service' && !!hasAccount && channelChat.status === 'open') {
                        return <span className="color-gray-4 pointer font-weight-light mr-3" key={item}
                                     onClick={this.toggleSendServicesModal}>
                            <i className="fa fa-database"/> <Translate id="sendServices"/>
                          </span>
                      }
                      if( item !== 'send_service' && item !== 'custom_folder' ) {
                        return <span className="color-gray-4 pointer font-weight-light mr-3" key={item}
                                      onClick={this.toggleWorkRequest}>
                            <i className="fa fa-folder"/> <Translate id={item}/>
                          </span>
                      }
                    } )
                    }

                    {!!extraMenu && extraMenu.length > 2 && !activeClientFolder && ( ( channelChat.status !== 'closed' ) ) &&
                    <IconMenu
                      iconButtonElement={<IconButton className="p-0" style={{ width: 24, height: 24 }} touch
                                                     tooltipPosition="bottom-left">
                        <MoreHorizIcon color="#666666"/>
                      </IconButton>}
                    >
                      {_.map( extraMenu, (item, keyID )=> {
                        if( item === 'custom_folder' && !!hasAccount ) {
                          return (
                            <MenuItem key={keyID} style={{ padding: 5, color: '#333333', lineHeight: '30px', minHeight: 30 }}
                                      onClick={this.toggleClientFolder}>
                              <span><i className="fa fa-folder"/> <Translate id="clientFolder"/></span>
                            </MenuItem>
                          )
                        }
                        if( item === 'send_service' && !activeClientFolder && !activeWorkRequest && !!hasAccount && channelChat.status !== 'closed') {
                          return (
                            <MenuItem key={keyID} style={{ padding: 5, color: '#333333', lineHeight: '30px', minHeight: 30 }}
                                      onClick={this.toggleSendServicesModal}>
                              <i className="fa fa-database"/> <Translate id="sendServices"/>
                            </MenuItem>
                          )
                        }
                        if( item === 'work_requests' ) {
                          return (
                            <MenuItem key={keyID} style={{ padding: 5, color: '#333333', lineHeight: '30px', minHeight: 30 }}
                                      onClick={this.toggleWorkRequest}>
                              <span><i className="fa fa-folder"/> <Translate id="work_requests"/></span>
                            </MenuItem>
                          )
                        }
                        if( item !== 'send_service' && item !== 'custom_folder' ) {
                          return (
                            <MenuItem key={keyID} style={{ padding: 5, color: '#333333', lineHeight: '30px', minHeight: 30 }}>
                              <i className="fa fa-folder"/> <Translate id={item}/>
                            </MenuItem>
                          )
                        }
                      } )}
                    </IconMenu>
                    }

                    {(!activeClientFolder && !activeWorkRequest ) ?
                    <i className="icon-close py-2 pl-2 pointer text-md"
                       onClick={activeChat ? this.onCloseActiveChat : this.onCloseActiveChannel}/> :
                       <div>
                       { activeClientFolder && 
                        <span className="color-gray-4 pointer font-weight-light mr-3"
                              onClick={this.toggleClientFolder}>
                            <span><i className="fa fa-folder-open"/> <Translate id="close"/></span>
                        </span>
                       }
                       { activeWorkRequest && 
                        <span className="color-gray-4 pointer font-weight-light mr-3"
                              onClick={this.toggleWorkRequest}>
                            <span><i className="fa fa-folder-open"/> <Translate id="close"/></span>
                        </span>
                       }
                       </div> 
                       
                    }

                  </div>
                </div>
              </div>
            </div>
            }

            {activeClientFolder &&
            <SimplePanel className="m-0 no-shadow no-border-radius"
                         contentClassName="box-center p-0">
              {this.props.clientFolderIframe ?
                <div>
                  { externalCustomer === 'kplc' &&  <ClientFolderHeader channel={activeChannel ? activeChannel : activeChat}/> } 
                  <div className="row">
                    <iframe id="myIframe" className="full-width" src=""/>
                  </div>
                </div>
                 :
                <ClientFolder channel={activeChannel ? activeChannel : activeChat}/>
              }
            </SimplePanel>
            }
            {activeWorkRequest &&
            <SimplePanel className="m-0 no-shadow no-border-radius"
                         contentClassName="box-center p-0">
              {this.props.clientFolderIframe &&
                <iframe id="myIframeWorkRequest" className="full-width" src=""/>
              }
              {((!this.props.clientFolderIframe) &&  (workRequestTabIndex===0) ) &&            
                <WorkRequest
                  channel={activeChannel ? activeChannel : activeChat} 
                  activeAccount={hasAccount ? this.props.activeAccount: false}
                  onClose={this.toggleWorkRequest}
                  onReloadChannel={() => {
                                this.reloadStatusChangeOnChannel( activeChannel.id );
                              }}
                  selectedTab={workRequestTabIndex}
                  setTab={this.setWorkRequestTabIndex}
                />
              }
              {((!this.props.clientFolderIframe) && (workRequestTabIndex===1)) &&
                <WorkRequestOwnership 
                    channel={activeChannel ? activeChannel : activeChat} 
                    activeAccount={this.props.activeAccount}
                    onClose={this.toggleWorkRequest}
                    onReloadChannel={() => {
                                  this.reloadStatusChangeOnChannel( activeChannel.id );
                                }}
                    selectedTab={workRequestTabIndex}
                    setTab={this.setWorkRequestTabIndex}
                  />
              }
              {((!this.props.clientFolderIframe) && (workRequestTabIndex===2)) &&
                <WorkRequestTenant
                    channel={activeChannel ? activeChannel : activeChat} 
                    activeAccount={this.props.activeAccount}
                    onClose={this.toggleWorkRequest}
                    onReloadChannel={() => {
                                  this.reloadStatusChangeOnChannel( activeChannel.id );
                                }}
                    selectedTab={workRequestTabIndex}
                    setTab={this.setWorkRequestTabIndex}
                  />
              }
              {((!this.props.clientFolderIframe) && (workRequestTabIndex===3)) &&
                <WorkRequestPowerUpgrade
                    channel={activeChannel ? activeChannel : activeChat} 
                    activeAccount={this.props.activeAccount}
                    onClose={this.toggleWorkRequest}
                    onReloadChannel={() => {
                                  this.reloadStatusChangeOnChannel( activeChannel.id );
                                }}
                    selectedTab={workRequestTabIndex}
                    setTab={this.setWorkRequestTabIndex}
                  />
              }
            </SimplePanel>
            }
            <div className={classNames( { 'd-none': ( activeClientFolder || activeWorkRequest )} )}>
              {activeChannel ?
                <ChannelDetail data={activeChannel}
                               activeAccount={this.props.activeAccount}
                               options={options}
                               onReloadData={() => this.getChannel( activeChannel.id )}
                               onReloadClosedChannel={() => {
                                 this.reloadStatusChangeOnChannel( activeChannel.id, this.onCloseActiveChannel );
                               }}
                               onReloadChannel={() => {
                                 this.reloadStatusChangeOnChannel( activeChannel.id );
                               }}
                               onAssign={() => this.toggleSelectedChannels( activeChannel, true )}
                /> :
                activeChat ?
                  <ChatDetail data={activeChat}
                              messages={this.messages}
                              hasMore={this.messagesHasMore}
                              date={messagesDate}
                              options={options}
                              onReloadData={() => this.getChat( activeChat.id )}
                              onLoadMore={this.getChatMessages}
                              onReloadClosedChannel={() => {
                                this.reloadStatusChangeOnChat( activeChat.id, this.onCloseActiveChat );
                              }}
                              onReloadChannel={() => {
                                this.reloadStatusChangeOnChat( activeChat.id );
                              }}
                              onAssign={() => this.toggleSelectedChats( activeChat, true )}
                  /> :
                  <SimplePanel className="m-0 no-shadow border-y border-gray-1 no-border"
                               contentClassName="box-unload-channel d-flex justify-content-center align-items-center">
                    <h4 className="text-muted"><Translate id="noAvailableElements"/></h4>
                  </SimplePanel>
              }
            </div>
          </div>
        }

        <div className={classNames( 'col-md-3 p-0', { 'd-none': ( activeClientFolder || activeWorkRequest) } )}>
          <div className="box box-default box-right m-0">
            <div className="box-header pointer p-0 border-bottom-0">
              <Paper zDepth={1} style={{ boxShadow: 'none', borderBottom: '1px solid #E9E9E9' }}>
                <BottomNavigation selectedIndex={selectedRightTabIndex} style={{ height: 48 }}>
                  <BottomNavigationItem
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                    disabled={!activeChannel && !activeChat}
                    label={
                      <div>
                        <i className="icon-user mr-1"/>
                        <Translate id="profile"/>
                      </div>}
                    icon={<span/>}
                    onClick={() => this.setActiveTabRight( 0 )}
                  />
                  <BottomNavigationItem
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                    disabled={!activeChannel && !activeChat}
                    label={
                      <div>
                        <i className="icon-clock mr-1"/>
                        <Translate id="historical"/>
                      </div>}
                    icon={<span/>}
                    onClick={() => this.setActiveTabRight( 1 )}
                  />
                </BottomNavigation>
              </Paper>
            </div>

            {( selectedRightTabIndex === 0 || selectedRightTabIndex === 1 ) &&
            <div className="box-body">
              {selectedRightTabIndex === 0 ?
                activeChannel ?
                  <ProfileTab channel={activeChannel}
                              onReloadData={this.getChannel}
                              onReloadActiveChannel={this.reloadActiveChannel}
                  /> :
                  activeChat ?
                    <ProfileTab channel={activeChat}
                                onReloadData={this.getChat}
                                onReloadActiveChannel={this.reloadActiveChat}
                    /> : null : null
              }

              {selectedRightTabIndex === 1 ?
                activeChannel ?
                  <Timeline data={activeChannel} messages={channelHistorical}
                            loadMore={( filters ) => this.getChannelHistorical( activeChannel.id, filters )}
                            onReloadData={( filters ) => this.getChannelHistorical( activeChannel.id, filters, true )}
                  /> :
                  activeChat ?
                    <Timeline data={activeChat}
                              messages={channelHistorical}
                              loadMore={( filters ) => this.getChannelHistorical( activeChat.id, filters )}
                              onReloadData={( filters ) => this.getChannelHistorical( activeChat.id, filters, true )}
                    /> : null : null
              }
            </div>
            }

            {selectedRightTabIndex !== 0 && selectedRightTabIndex !== 1 && <div className="box-body"/>}
          </div>
        </div>

        {(externalCustomer !== 'lec'  ) &&
          <SendServicesModal open={sendServicesModalOpened}
                            onClose={this.toggleSendServicesModal}
          />
        }
        {(externalCustomer === 'lec' ||  externalCustomer === 'escom' ) &&
          <SendServicesLECModal open={sendServicesModalOpened}
                            onClose={this.toggleSendServicesModal}
                            activeAccount={this.props.activeAccount}
          />
        }


        <PhoneCallModal open={this.state.phoneCallModalOpened}
                        data={{ phoneCalling: this.state.phoneCalling }}
                        onClose={this.togglePhoneCallModal}
                        onReloadData={this.reloadChannelPhoneOpenedData}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  activeAccount: state.channelDetail.activeAccount,
  lastCall: state.channelDetail.lastCall,
  phoneCalling: state.channelDetail.phoneCalling,
  loadChannelId: state.channelDetail.loadChannelId,
  loadChannelDate: state.channelDetail.loadChannelDate,
  notifications: state.notifications,
  user: state.user,
  locale: state.locale,
  newMessageData: state.websocket.newMessageData,
  newMessageDataDate: state.websocket.newMessageDataDate,
  newMessageFileData: state.websocket.newMessageFileData,
  newMessageFileDataDate: state.websocket.newMessageFileDataDate,
  chatActive: state.settings.chatActive,
  clientFolderIframe: state.settings.clientFolderIframe,
  externalCodes: state.settings.externalCodes,
  externalCustomer: state.settings.externalCustomer,
  extraMenu: _.get( state, 'settings.extraMenu', [] ) || []
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  updateNotifications: ( data ) => {
    dispatch( updateNotifications( data ) );
  },
  checkUserOnline: ( data ) => {
    dispatch( checkUserOnline( data ) );
  }
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( injectIntl(Agent) );



// WEBPACK FOOTER //
// ./routes/app/routes/agent/index.js